import React, { useState } from "react";
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useAuth } from "../../AuthContext";

const interceptor = () => {
    const { setIsApiLoading } = useAuth();
    const [isLoading, setIsLoading] = useState(false)
    axios.interceptors.request.use((config) => {
        const AUTH_TOKEN = localStorage.getItem("token")
        let isLogin = (config && config.url && config.url.split("/")[config.url.split("/").length - 1] === 'login')
        let checkAuthorization = (config && config.url && config.url.split("/")[config.url.split("/").length - 1] === 'checkAuthorization')

        if (config && config.headers && !(isLogin))
            config.headers.Authorization = `Bearer ${AUTH_TOKEN}`;
        if (!AUTH_TOKEN && !(isLogin)) {
            localStorage.clear();
            window.location.href = "/login";
        }
        if (!checkAuthorization) {
            setIsLoading(true)
            setIsApiLoading(true)
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    axios.interceptors.response.use(
        response => {
            setIsLoading(false)
            // setTimeout(() => {
            //     setIsApiLoading(false);
            // }, 1000);
            return response
        }, (error) => {
            setIsLoading(false)
            setIsApiLoading(false)
            if (axios.isAxiosError(error)) {
                if (error.response) {
                    if (error.response.status === 401) {
                        localStorage.clear();
                        window.location.href = "/login";
                        // window.location.reload()
                    } else if (error.response.status === 403) {
                        localStorage.clear();
                        window.location.href = "/login";
                        // window.location.reload()
                    } else if (error.response.status === 503) {
                        localStorage.clear();
                        window.location.href = "/login";
                    }
                }
            }
            return Promise.reject(error);
        }
    )

    return (
        <div>
            {isLoading &&
                <div
                    style={{
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        justifyContent: 'center',
                        position: 'absolute',
                        alignItems: 'center'
                    }}
                    className="loading-One"
                >
                    <Box
                        sx={{
                            position: 'relative',
                            zIndex: 2,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%', // or specific height if needed
                        }}
                    >
                        <CircularProgress size={40} color="primary" />
                    </Box>
                </div>
            }
        </div >
    )
}
export default interceptor;